import Vue from "vue";
import Vuex from "vuex";
import axios from "./api.js";

const mongoObjectId = () => {
  let timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
  // eslint-disable-next-line
  return (
    timestamp +
    "xxxxxxxxxxxxxxxx"
      .replace(/[x]/g, () => {
        return ((Math.random() * 16) | 0).toString(16);
      })
      // eslint-disable-next-line
      .toLowerCase()
  );
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // user
    userInfo: {
      customerId: "",
      customerUserId: "",
      apiKey: ""
    },
    // components
    components: [],
    // form
    activeForm: {},
    // registration
    activeRegistration: {},
    templateRegistration: {},
    // repeaterRegistration
    repeaterRegistrations: [],
    activeRepeaterRegistration: {},
    // map
    position: null,
    showInfoMap: true,
    // images
    photos: [],
    repeaterPhotos: [],
    // modal
    showModal: false,
    // langauge
    languages: [
      {
        flag: "denmark",
        text: "Dansk",
        shorten: "dk",
        selected: false
      },
      {
        flag: "sweden",
        text: "Svenska",
        shorten: "se",
        selected: false
      },
      {
        flag: "norway",
        text: "Norsk",
        shorten: "no",
        selected: false
      },
      {
        flag: "united-kingdom",
        text: "English",
        shorten: "en",
        selected: false
      }
    ],
    selectedLanguage: {},
    showLanguageMenu: false
  },
  getters: {
    // user
    getUserData: state => {
      return state.userInfo;
    },
    // components
    getComponents: state => {
      return state.components;
    },
    // form
    getActiveForm: state => {
      return state.activeForm;
    },
    // registration
    getActiveRegistration: state => {
      return state.activeRegistration;
    },
    // repeaterRegistration
    getActiveRepeaterRegistration: state => {
      return state.activeRepeaterRegistration;
    },
    getRepeaterItems: state => {
      return state.repeaterRegistrations;
    },
    // map
    getPosition: state => {
      if (state.activeRegistration && state.activeRegistration.location) {
        return state.activeRegistration.location;
      } else {
        return null;
      }
    },
    getShowInfoMap: state => {
      return state.showInfoMap;
    },
    // images
    getImages: state => {
      return state.photos;
    },
    getRepeaterImages: state => {
      return state.repeaterPhotos;
    },
    getImagesOnRepeater: state => {
      // eslint-disable-next-line
      if (
        state.activeRepeaterRegistration &&
        state.activeRepeaterRegistration.uploads
      ) {
        return state.activeRepeaterRegistration.uploads;
      } else {
        return state.activeRepeaterRegistration;
      }
    },
    // modal
    getShowModal: state => {
      return state.showModal;
    },
    // languages
    getLanguages: state => {
      return state.languages;
    },
    getSelectedLanguage: state => {
      return state.selectedLanguage;
    },
    getShowLanguageMenu: state => {
      return state.showLanguageMenu;
    }
  },
  mutations: {
    // eslint-disable-next-line
    errorHandler: (state, error) => {
      console.log("error", error);
    },
    // user
    setUserData: (state, payload) => {
      state.userInfo = payload;
      //console.log("state.userInfo: ", state.userInfo);
    },
    setComponents: (state, payload) => {
      state.components = payload;
    },
    setDefaultComponentActive: state => {
      let template = JSON.parse(JSON.stringify(state.templateRegistration));
      state.activeRegistration = template;
      state.photos = [];
      state.position = null;
      state.components.forEach((comp, index) => {
        if (index === 0) {
          comp.active = true;
        } else {
          comp.active = false;
        }
      });
    },
    // form
    setActiveForm: (state, payload) => {
      // SKAL FIXES
      if (payload) {
        payload.mapEnabled = true;
        payload.photoEnabled = true;
        state.activeForm = payload;
      }
    },
    // registration
    handleNextStep: state => {
      let selectedIndex = null;
      for (let i = 0; state.components.length > i; i++) {
        if (selectedIndex !== null) {
          if (!state.components[i].disabled) {
            state.components[i].active = true;
            break;
          }
        }
        if (state.components[i].active) {
          state.components[i].active = false;
          selectedIndex = i;
        }
      }
    },
    handlePreviousStep: state => {
      let selectedIndex = null;
      // eslint-disable-next-line
      for (
        let i = state.components.length - 1;
        state.components.length > i;
        i--
      ) {
        if (i < 0) {
          break;
        }
        if (selectedIndex !== null) {
          if (!state.components[i].disabled) {
            state.components[i].active = true;
            break;
          }
        }
        if (state.components[i].active) {
          state.components[i].active = false;
          selectedIndex = i;
        }
      }
    },
    setActiveRegistration: (state, registration) => {
      if (registration) {
        registration.formRegistrationId = mongoObjectId();
        registration.geoJson = {};
        state.activeRegistration = registration;
      }
    },
    setTemplateRegistration: (state, registration) => {
      if (registration) {
        let template = JSON.parse(JSON.stringify(registration));
        // const template = Object.assign({}, registration);
        template.geoJson = {};
        state.photos = [];
        state.position = null;
        state.templateRegistration = template;
      }
    },
    setActiveRepeaterRegistration: (state, payload) => {
      state.activeRepeaterRegistration = payload;
    },
    savePositionOnRepeater: (state, payload) => {
      let object = {
        type: "Point",
        coordinates: []
      };
      let z = 0.0;

      object.coordinates.push(payload.lng, payload.lat, z);
      state.activeRepeaterRegistration.location = object;
    },
    addRepeater: (state, payload) => {
      payload.createdDateTime = new Date().toISOString();
      payload.lastModifiedDatetime = new Date().toISOString();
      state.repeaterRegistrations.push(payload);
    },
    addExistingRepeaterImages: (state, payload) => {
      if (payload.length > 0) {
        state.activeRepeaterRegistration.uploads = payload;
      } else {
        state.activeRepeaterRegistration.uploads = [];
      }
    },
    updateRepeater: (state, payload) => {
      for (let i in state.repeaterRegistrations) {
        if (
          state.repeaterRegistrations[i].repeaterRegistrationId ===
          payload.repeaterRegistrationId
        ) {
          state.repeaterRegistrations[i].title = payload.title;
          state.repeaterRegistrations[i].createdDateTime =
            payload.createdDateTime;
          state.repeaterRegistrations[i].customerUserId =
            payload.customerUserId;
          state.repeaterRegistrations[i].formElements = payload.formElements;
          state.repeaterRegistrations[i].formId = payload.formId;
          state.repeaterRegistrations[i].formRegistrationId =
            payload.formRegistrationId;
          state.repeaterRegistrations[i].geoJson = payload.geoJson;
          state.repeaterRegistrations[
            i
          ].lastModifiedDatetime = new Date().toISOString();
          state.repeaterRegistrations[i].lastSyncedDateTime =
            payload.lastSyncedDateTime;
          state.repeaterRegistrations[i].location = payload.location;
          state.repeaterRegistrations[i].repeaterId = payload.repeaterId;
          state.repeaterRegistrations[i].repeaterRegistrationId =
            payload.repeaterRegistrationId;
          state.repeaterRegistrations[i].revisionNo = payload.revisionNo;
          state.repeaterRegistrations[i].uploads = payload.uploads;
        }
      }
    },
    // map
    savePosition: (state, payload) => {
      let object = {
        type: "Point",
        coordinates: []
      };
      let z = 0.0;

      if (payload.lng) {
        object.coordinates.push(payload.lng, payload.lat, z);
      } else {
        // eslint-disable-next-line
        object.coordinates.push(
          payload.coords.longitude,
          payload.coords.latitude
        );
      }

      if (state.activeRegistration) {
        state.activeRegistration.location = object;
      } else {
        state.activeRegistration = {};
        state.activeRegistration.location = object;
      }
    },
    setShowInfoMap: (state, payload) => {
      state.showInfoMap = payload;
    },
    // images
    addImage: (state, payload) => {
      if (payload) {
        if (Array.isArray(payload)) {
          state.photos = payload;
        } else {
          state.photos.push(payload);
        }
      }
    },
    addUploadToActiveRegistration: (state, payload) => {
      // eslint-disable-next-line
      if (
        state.activeRegistration.uploads &&
        Array.isArray(state.activeRegistration.uploads)
      ) {
        state.activeRegistration.uploads.push(payload);
      } else {
        state.activeRegistration.uploads = [payload];
      }
    },
    removeImage: (state, payload) => {
      state.photos.splice(payload.index, 1);
    },
    addImageOnRepeater: (state, payload) => {
      state.activeRepeaterRegistration.uploads.push(payload);
      state.repeaterPhotos.push(payload);
    },
    removeImageFromRepeater: (state, payload) => {
      state.activeRepeaterRegistration.uploads.splice(payload.index, 1);
    },
    clearRepeaterRegistrations: state => {
      state.repeaterRegistrations = [];
    },
    setCaptionImage: (state, image) => {
      state.activeRegistration.uploads.forEach(upload => {
        if (upload.uploadId === image.id) {
          upload.caption = image.caption;
        }
      });
    },
    // modal
    toggleModal: (state, boolean) => {
      state.showModal = boolean;
    },
    setSelectedLanguage: (state, language) => {
      state.languages.forEach(lang => {
        if (lang.text === language.text) {
          lang.selected = true;
        } else {
          lang.selected = false;
        }
      });
      state.selectedLanguage = language;
      state.showLanguageMenu = false;
    },
    setShowLanguageMenu: state => {
      state.showLanguageMenu = !state.showLanguageMenu;
    }
  },
  actions: {
    // create error log
    // eslint-disable-next-line
    setErrorLog: ({ commit }, payload) => {
      console.log("setErrorLog: ", payload);
      return axios.post("/api/v2/clienterrorlog", payload).then(() => {
        return true;
      });
    },
    // user (remember to add param)
    setupRegistrationData: ({ commit }, param) => {
      return axios
        .get("/api/public/" + param.formId + "?apiKey=" + param.apiKey, {
          headers: {
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(
          response => {
            //console.log("userInfo:", response.data.userData);
            commit("setUserData", response.data.userData);
            commit("setActiveForm", response.data.form);
            commit("setActiveRegistration", response.data.registration);
            commit("setTemplateRegistration", response.data.registration);
          },
          error => {
            commit("errorHandler", error);
          }
        );
    },
    // components
    setComponents: ({ commit }, components) => {
      commit("setComponents", components);
    },
    setDefaultComponentActive: ({ commit }) => {
      commit("setDefaultComponentActive");
    },
    // registration
    handleNextStep: ({ commit }) => {
      commit("handleNextStep");
    },
    handlePreviousStep: ({ commit }) => {
      commit("handlePreviousStep");
    },
    submitFormToServer: ({ state }) => {
      let submitForm = [];
      state.activeRegistration.createdDateTime = new Date().toISOString()
      submitForm.push(state.activeRegistration);
      state.repeaterRegistrations.forEach(rep => {
        submitForm.push(rep);
      });
      // let submitForm = {
      //   Registration: state.activeRegistration,
      //   RepeaterRegistrations: state.repeaterRegistrations
      //     ? state.repeaterRegistrations
      //     : []
      // };
      return axios.post("/api/public", { registrations: submitForm }).then(
        response => {
          console.log("response", response);
          return true;
        },
        error => {
          console.log("Error: ", error);
          return "error";
        }
      );
    },
    // repeaterRegistration
    setActiveRepeaterRegistration: ({ commit, state }, object) => {
      if (object.userAction === "create") {
        let template = JSON.parse(JSON.stringify(state.templateRegistration));
        let repeaterRegistrationTemplate = template;
        let formRegistrationId = object.activeRegistration.formRegistrationId; // fra parent registrering
        let repeaterRegistrationId = mongoObjectId();
        let formId = state.activeForm.formId ? state.activeForm.formId : null;
        let customerId = state.userInfo.customerId
          ? state.userInfo.customerId
          : null;

        repeaterRegistrationTemplate.formRegistrationId = repeaterRegistrationId;
        repeaterRegistrationTemplate.parentId = formRegistrationId;
        repeaterRegistrationTemplate.formId = formId;
        repeaterRegistrationTemplate.repeaterId =
          object.repeaterRegistration.formElementId;
        repeaterRegistrationTemplate.customerId = customerId;
        repeaterRegistrationTemplate.uploads = [];
        repeaterRegistrationTemplate.location = null;
        repeaterRegistrationTemplate.formElements = [];

        for (let i in object.repeaterRegistration.dynamicTypeData
          .childElements) {
          repeaterRegistrationTemplate.formElements.push(
            object.repeaterRegistration.dynamicTypeData.childElements[i]
          );
        }
        commit("setActiveRepeaterRegistration", repeaterRegistrationTemplate);
      } else if (object.userAction === "clear") {
        commit("setActiveRepeaterRegistration", {});
      } else {
        commit("setActiveRepeaterRegistration", object.repeaterRegistration);
      }
    },
    addRepeater: ({ commit }, data) => {
      commit("addRepeater", data);
    },
    updateRepeater: ({ commit }, data) => {
      commit("updateRepeater", data);
    },
    getRepeaterPhotosFromExistingRegistration: (
      { commit, state },
      registrationId
    ) => {
      let repeaterPhotos = [];
      state.repeaterRegistrations.forEach(repeater => {
        if (repeater.repeaterRegistrationId === registrationId) {
          repeaterPhotos = repeater.uploads;
        }
      });

      commit("addExistingRepeaterImages", repeaterPhotos);
    },
    // map
    getMapLayers: () => {
      console.log("get map layers");
    },
    clickedGeometry: () => {
      console.log("clicked geometry");
    },
    savePosition: ({ commit }, position) => {
      commit("savePosition", position);
    },
    savePositionOnRepeater: ({ commit }, position) => {
      commit("savePositionOnRepeater", position);
    },
    setShowInfoMap: ({ commit }, boolean) => {
      commit("setShowInfoMap", boolean);
    },
    // images
    addImage: ({ commit }, image) => {
      commit("addImage", image);
    },
    addUploadToActiveRegistration: ({ commit }, upload) => {
      commit("addUploadToActiveRegistration", upload);
    },
    removeImage: ({ commit }, data) => {
      commit("removeImage", data);
    },
    addImageOnRepeater: ({ commit }, image) => {
      commit("addImageOnRepeater", image);
    },
    removeImageFromRepeater: ({ commit }, data) => {
      commit("removeImageFromRepeater", data);
    },
    clearRepeaterRegistrations: ({ commit }) => {
      commit("clearRepeaterRegistrations");
    },
    setCaptionImage: ({ commit }, image) => {
      commit("setCaptionImage", image);
    },
    // modal
    toggleModal: ({ commit }, boolean) => {
      commit("toggleModal", boolean);
    },
    // language
    setSelectedLanguage: ({ commit }, language) => {
      commit("setSelectedLanguage", language);
    },
    setShowLanguageMenu: ({ commit }) => {
      commit("setShowLanguageMenu");
    }
  }
});
